import { render, staticRenderFns } from "./ResetSecurityProfileNewPwd.vue?vue&type=template&id=0386d224&scoped=true"
import script from "./ResetSecurityProfileNewPwd.vue?vue&type=script&lang=js"
export * from "./ResetSecurityProfileNewPwd.vue?vue&type=script&lang=js"
import style0 from "./ResetSecurityProfileNewPwd.vue?vue&type=style&index=0&id=0386d224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0386d224",
  null
  
)

export default component.exports